import { render, staticRenderFns } from "./BoardFilterLink.vue?vue&type=template&id=9a75f158&scoped=true&"
import script from "./BoardFilterLink.vue?vue&type=script&lang=js&"
export * from "./BoardFilterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a75f158",
  null
  
)

export default component.exports